import { Breadcrumbs } from '@prisjakt/ui/breadcrumbs';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from 'src/components/app-context';
import { media } from 'src/components/base';
import { CategoryList } from 'src/components/category-list';
import type { CategoryWithLogo } from 'src/components/category-list/types';
import { PageHeader } from 'src/components/page';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import type { CategoryPageQuery } from 'src/types';
import styled from 'styled-components';
import { BreadCrumbWrapper } from '../../styles';

const icon = 'https://cdn.pji.nu/g/cat/192/tjanster.png';

const Gutter = styled.div`
  padding-left: 0.8rem;
  padding-right: 0.8rem;
`;

const DescriptionText = styled.div`
  max-width: 500px;
  font-size: 14px;
  color: ${p => p.theme.text.secondary};

  ${media.smallOnly`
    font-size: 13px;
  `}
`;

export const Services = ({ data }: { data: CategoryPageQuery }) => {
  const { t } = useContext(AppContext);

  const { categoryTree } = data;

  const services =
    categoryTree &&
    categoryTree[0]?.children?.reduce<CategoryWithLogo[] | []>((acc, child) => {
      const newChild = child
        ? ({
            ...child,
            logo: {
              192: child.logo,
            },
          } as CategoryWithLogo)
        : null;

      return newChild ? [...acc, newChild] : acc;
    }, []);

  return (
    <>
      <BreadCrumbWrapper>
        <Breadcrumbs
          containerProps={{
            onClick: (nextPage: string) => {
              trackInternalNavigationClick({
                scope: InternalNavigationScope.BREADCRUMB,
                nextPage,
              });
            },
          }}
        >
          <Link to="/">{t('common', 'breadcrumb.home')}</Link>
          <span>{t('category', 'service-list.title')}</span>
        </Breadcrumbs>
      </BreadCrumbWrapper>

      <PageHeader
        media={
          <img
            width={100}
            alt={t('category', 'service-list.title')}
            src={icon}
          />
        }
        title={t('category', 'service-list.title')}
      >
        <DescriptionText>
          {t('category', 'service-list.description')}
        </DescriptionText>
      </PageHeader>
      <Gutter>
        <CategoryList categories={services ?? []} withAds />
      </Gutter>
    </>
  );
};
